// Week 8 / Day 4 — Данные компании, тренд и точка без потерь / Company Data, Trend and Break-Even
// Solid Grade 6 math + RU Grade 3–4. Educational model.

export const maxWeek8Day4 = {
  id: 'max-week-8-day-4',
  studentId: 'max',
  weekId: 'week-8',
  dayId: 'day-4',
  title: 'Данные компании, тренд и точка без потерь / Company Data, Trend and Break-Even',
  shortTitle: 'Данные и тренд / Data and Trend',
  theme:
    'Макс анализирует таблицу результатов, изменение показателей и простую модель покрытия ресурсов. / Max analyses data, growth/decline and a break-even model.',
  estimatedTimeLabel: 'Онлайн: 25–35 мин. Полный день: 80–100 мин. / Online: 25–35 min. Full day: 80–100 min.',
  nimnyIntro:
    'Нимни ведёт Макса через среднее/медиану/размах, процент роста/снижения, точку покрытия и тренд по таблице. / Nimny walks Max through mean/median/range, growth vs decline %, break-even and a trend table.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: анализ данных, % роста и снижения, уравнение покрытия, тренд по таблице (Grade 6). / data + growth/decline % + break-even + trend.',
    'Слой 2. Русский / Layer 2. Russian: части речи, безударные, исправление.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: короткий текст о показателях + план + 4 предложения.',
    'Слой 4. Наблюдение и логика / Layer 4. Observation and logic: проверить утверждение по данным.',
    'Слой 5. Практика: короткий отчёт по данным. / Practical: short data report.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 3/5.'
  ],
  vocabulary: [
    { term: 'данные / data', definition: 'числа, собранные за несколько периодов / numbers collected over periods' },
    { term: 'показатель / metric', definition: 'одно число, которое мы измеряем / a single measured number' },
    { term: 'рост / growth', definition: 'увеличение значения / increase of value' },
    { term: 'снижение / decline', definition: 'уменьшение значения / decrease of value' },
    { term: 'среднее / mean', definition: 'сумма ÷ количество / sum / count' },
    { term: 'вывод / conclusion', definition: 'что мы поняли по данным / what we concluded from data' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Анализ данных / Data analysis',
      prompt: 'Периоды: 40, 48, 44, 60, 53. Найди сумму, среднее, медиану и размах. / Sum, mean, median, range.',
      helper: 'Сортируй перед медианой. / Sort for median.',
      answer: 'Сумма 245; среднее 49; медиана 48; размах 20. / 245 / 49 / 48 / 20.', unit: '' },
    { id: 'q2', type: 'math', title: 'Рост и снижение / Growth and decline',
      prompt: 'Значение выросло с 40 до 60, затем снизилось с 60 до 53. На сколько % рост и на сколько % снижение? / Growth % + decline %.',
      helper: 'Рост от 40; снижение от 60. / Different bases.',
      answer: 'Рост 50%; снижение ≈ 11.7%. / 50%; ~11.7%.', unit: '%' },
    { id: 'q3', type: 'math', title: 'Точка покрытия ресурсов / Break-even',
      prompt: 'Постоянные 120 баллов. Каждая единица требует ещё 6 баллов и даёт 10 баллов результата. Сколько единиц покроют ресурсы? / Solve 10x = 120 + 6x.',
      helper: 'Собери подобные. / Combine like terms.',
      answer: '30 единиц. / 30 units.', unit: 'единиц / units' },
    { id: 'q4', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'данные / data' },
        { id: 'w2', text: 'растущий / growing' },
        { id: 'w3', text: 'снижаться / to decline' },
        { id: 'w4', text: 'вывод / conclusion' },
        { id: 'w5', text: 'стабильный / stable' },
        { id: 'w6', text: 'анализировать / to analyse' }
      ] },
    { id: 'q5', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «одно чесло не показывает всю картину, поэтаму мы анализируим несколько периодов». / Rewrite without mistakes.',
      placeholder: 'Одно число... / One number...' },
    { id: 'q6', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «Не одно число» на печатном листе. Главная мысль, план из 3 пунктов и 4 предложения. / Main idea + plan + 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q7', type: 'text', title: 'Логика: проверь утверждение / Logic: check the claim',
      prompt: 'Утверждение: «Показатель вырос в последний день, поэтому весь проект постоянно растёт». Проверь по таблице (6.5/7/7/8.5/8) и объясни ошибку. / Verify with table.',
      placeholder: 'В последний день... / On the last day...' },
    { id: 'q8', type: 'text', title: 'Практика: короткий отчёт по данным / Practical: short data report',
      prompt: 'Опиши свои учебные данные (сон/минуты/оценки) за 5 периодов: среднее, самый большой рост, точка максимума. / 5-period report.',
      placeholder: 'Данные: ... Среднее: ... Рост: ... Максимум: ...' },
    { id: 'q9', type: 'essay', title: 'Что говорит одно число / What a single number says',
      prompt: '3–5 предложений: почему одного числа недостаточно для вывода. Приведи пример. / 3–5 sentences with example.',
      minSentences: 3, maxSentences: 6, placeholder: 'Одно число... / A single number...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 8, День 4». / Heading.',
    'Слой 1. Математика: q1–q3 + MATH 4 (тренд по таблице) из печатного листа. / Math + trend.',
    'Слой 2. Русский: части речи + исправление. / Russian.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: проверить утверждение. / Logic.',
    'Слой 5. Практика: короткий отчёт по данным. / Practical.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 8, День 4 / Week 8, Day 4',
    subtitle: 'Данные компании, тренд и точка без потерь / Company Data, Trend and Break-Even',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Наблюдение и логика: проверка утверждения / Verify the claim — 5–10 мин / min.',
          '5. Практика: короткий отчёт по данным / Data report — 10–15 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: анализ данных, проценты роста/снижения, break-even, тренд по таблице. Показывай шаги. / Show steps.' },
        { type: 'list', items: [
          '1) 40 + 48 + 44 + 60 + 53 = ____. Среднее ____ ÷ 5 = ____. Сортировка: ____, ____, ____, ____, ____. Медиана ____. Размах 60 − 40 = ____. / Data.',
          '2) Рост: 60 − 40 = 20; 20 ÷ 40 = ____ = ____%. Снижение: 60 − 53 = 7; 7 ÷ 60 ≈ ____ = ____%. / Growth/decline.',
          '3) 10x = 120 + 6x. 4x = ____. x = ____ (break-even). / Equation.',
          '4) MATH 4 — Тренд по таблице качества 6.5/7/7/8.5/8: среднее ____; изменения +0.5/0/+1.5/−0.5; самый большой рост Ср→Чт = ____; максимум Чт = ____; снижение Чт→Пт = ____. / Trend.',
          '5) Проверка / Check: 40 + 44 + 48 + 53 + 60 = ____? / Sum verify.',
          '6) Проверка / Check: 30 × 10 − 30 × 6 = ____ = 120? / Break-even verify.',
          '7) Optional / Доп.: 25% от 60 = ____ (в баллах). / Extra %.',
          '8) Optional / Доп.: если 30 единиц дают +40% результата, новое значение = 30 × 1.40 = ____. / Extra growth.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: часть речи по вопросу; безударные проверяем ударением. / Parts of speech + unstressed.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: данные, показатель, рост, снижение, среднее, вывод, тренд, анализ.',
          'Части речи / Parts of speech: данные, растущий, снижаться, вывод, стабильный, анализировать — раздели.',
          'Исправь ошибки / Fix mistakes: «одно чесло не показывает всю картину, поэтаму мы анализируим несколько периодов».',
          'Вставь букву / Insert vowel: п_казатель, ср_днее, сн_жение, ан_лиз.',
          'Мини-диктант / Mini-dictation: «Одно число не показывает всю картину, поэтому мы анализируем несколько периодов».'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «Не одно число» / Text: Одно число редко говорит всю правду. Оно показывает миг, а вывод строится по ряду мигов. Если смотреть только на последний день, легко ошибиться: он может быть выше или ниже среднего. Полезно взять несколько периодов, посчитать среднее, найти самый большой рост и самое сильное снижение. Только вместе эти показатели складываются в осмысленную картину. / A single number rarely tells the whole truth. Look at several periods, compute mean, growth and drop.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения о числах / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Наблюдение и логика: проверка утверждения / Layer 4. Verify the Claim', blocks: [
        { type: 'text', text: 'Готовая таблица качества (пн/вт/ср/чт/пт): 6.5 / 7 / 7 / 8.5 / 8. / Ready table 6.5/7/7/8.5/8.' },
        { type: 'list', items: [
          'Утверждение / Claim: «Показатель вырос в последний день, поэтому весь проект постоянно растёт».',
          'В последний день (Чт→Пт) значение стало 8 против 8.5. Это ____ (рост / снижение).',
          'Есть ли постоянный рост во всей таблице? / Constant growth in the whole series? — ____.',
          'Мой вывод / Conclusion: последний день показал снижение, а не рост. Утверждение ошибочно. / Claim is false.',
          'Пустое место для координатной сетки / Grid area for the line graph (уже подготовлено): ось X — дни (Пн, Вт, Ср, Чт, Пт); ось Y — 6.0…9.0. Отметь точки и соедини. / Prepared axes; plot the points.'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: короткий отчёт по данным / Layer 5. Practical Knowledge: data report', blocks: [
        { type: 'text', text: 'Возьми учебные данные за 5 периодов. Учебная запись, не медицинская. / Learning data, not medical.' },
        { type: 'list', items: [
          'Данные / Data: ____, ____, ____, ____, ____.',
          'Среднее / Mean: ____.',
          'Медиана / Median: ____.',
          'Максимум / Max: ____ (день ____).',
          'Самый большой рост между двумя днями / Biggest jump: ____ (день ____ → ____).',
          'Самое сильное снижение / Biggest drop: ____ (день ____ → ____).',
          'Вывод / Conclusion: __________________________________'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Что я понял про данные / What I learned about data: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 3 нима / nims ✓',
          'Бонус за break-even и тренд / Bonus for break-even + trend: +1 ☐',
          'Бонус за отчёт по данным / Bonus for a clear report: +1 ☐',
          'Итого / Total: ____ из / of 5 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: анализ {40,44,48,53,60}: 245/49/48/20; рост 50%, снижение ≈ 11.7%; break-even 10x = 120 + 6x → 30; тренд по таблице. Русский Grade 3–4. Учебная модель показателей. / Educational metrics model.',
    mathGoal: 'q1: 245/49/48/20. q2: 50% и ~11.7%. q3: 30 единиц. MATH 4 (print): среднее 7.4; Ср→Чт +1.5; Чт максимум 8.5; Чт→Пт снижение −0.5. / Listed with steps.',
    russianGoal: 'Существительные: данные, вывод. Глаголы: снижаться, анализировать. Прилагательные: растущий, стабильный.',
    readingWritingGoal: 'Главная мысль: одно число редко даёт весь ответ. План + 4 предложения. / Main idea + plan + 4 sentences.',
    practicalGoal: 'Короткий отчёт за 5 периодов с средним, максимумом, ростом и снижением. / 5-period data report.',
    check: [
      'Q1: 245 / 49 / 48 / 20.',
      'Q2: 50% и ≈ 11.7%.',
      'Q3: 30 единиц.',
      'MATH 4 (print): 7.4 / +1.5 / 8.5 / −0.5.',
      'Q4: части речи разобраны. / Parts of speech.',
      'Q5: исправление чистое. / Correction clean.',
      'Q6: главная мысль + план + 4 предложения. / Reading essentials.',
      'Q7: последний день был снижением, а не ростом. / Claim refuted.',
      'Q8: отчёт из 5 периодов. / 5-period report.',
      'Q9: 3–5 предложений. / 3–5 sentences.'
    ],
    answerKey: [
      { taskId: 'q1', answer: 'Ответ: Сумма 245; среднее 49; медиана 48; размах 20. Решение: 40 + 48 + 44 + 60 + 53 = 245; 245 ÷ 5 = 49; сортировка 40/44/48/53/60; медиана 48; 60 − 40 = 20. Подсказка родителю: Медиану считать только после сортировки.' },
      { taskId: 'q2', answer: 'Ответ: Рост 50%; снижение ≈ 11.7%. Решение: Рост: (60 − 40) ÷ 40 = 0.5 = 50%. Снижение: (60 − 53) ÷ 60 ≈ 0.1167 = 11.7%. Подсказка родителю: Разные базы: рост от 40, снижение от 60. Это одна из главных ловушек процентов.' },
      { taskId: 'q3', answer: 'Ответ: 30 единиц покрывают ресурсы. Решение: 10x = 120 + 6x; 4x = 120; x = 30. Проверка: 30 × 10 = 300; 120 + 30 × 6 = 300. Подсказка родителю: Break-even: результат = постоянная часть + расход на единицу.' },
      { taskId: 'q4', answer: 'Ответ: Существительные: данные, вывод. Глаголы: снижаться, анализировать. Прилагательные: растущий, стабильный. Решение: Часть речи определяется по вопросу. Подсказка родителю: «Растущий» — причастие в роли прилагательного, засчитывается как прилагательное.' },
      { taskId: 'q5', answer: 'Ответ: Одно число не показывает всю картину, поэтому мы анализируем несколько периодов. Решение: Исправлены: «чесло → число», «поэтаму → поэтому», «анализируим → анализируем». Подсказка родителю: Обратите внимание на «поэтому» — пишется слитно.' },
      { taskId: 'q6', answer: 'Ответ: Главная мысль: одно число редко даёт весь ответ. Решение: План: 1) миг vs ряд; 2) среднее / рост / снижение; 3) вывод по всем показателям сразу. Подсказка родителю: Пересказ 3–5 предложений по-русски.' },
      { taskId: 'q7', answer: 'Ответ: В последний день (Чт → Пт) значение снизилось с 8.5 до 8.0. Утверждение о постоянном росте неверно. Решение: Достаточно показать одну точку снижения по данным таблицы. Подсказка родителю: Принять любой ответ, где явно упомянут переход Чт → Пт.' },
      { taskId: 'q8', answer: 'Ответ: Открытый ответ: 5 периодов + среднее + максимум + самый большой рост + самое сильное снижение. Решение: Ребёнок использует свои учебные данные (сон / минуты / оценки). Подсказка родителю: Не собирать медицинские данные.' },
      { taskId: 'q9', answer: 'Ответ: 3–5 предложений о том, что одно число — миг, для вывода нужен ряд. Решение: Ожидаемый пример из таблицы q1 или q7. Подсказка родителю: Принимать любые примеры с обоснованием.' }
    ],
    logicRubric: 'Ребёнок должен явно указать на снижение в последний день. / Explicit reference to the last-day decline.',
    readingRubric: 'Пересказ 3–5 предложений; главная мысль о нескольких периодах. / Essentials.',
    parentNotes: [
      'Это учебная модель показателей, а не финансовая рекомендация. / Educational, not advice.',
      'Разные базы для процентов: рост берётся от начального, снижение — от нового максимума. / Growth vs decline bases.',
      'Break-even: сравниваем поступление и ресурс на единицу. / Break-even = revenue vs per-unit cost.'
    ],
    spellingCheck: 'Части речи и правописание слов темы. / Parts of speech + theme words.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений. / Reading essentials.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Какой показатель важнее — среднее или размах? / Mean or range?',
      'Где ты видел ложный вывод по одному числу? / Where have you seen a false claim from one number?',
      'Зачем считать медиану, если есть среднее? / Why median if we have mean?',
      'Как тренд помогает решению? / How does trend help decisions?'
    ],
    ifEasy: 'Усложни: посчитай 25% от 60 и добавь к 60. / Extend: 25% of 60.',
    ifDifficult: 'Оставь q1 и q3. / Keep q1 and q3.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 3, max: 5,
    label: 'Награда за завершение / Completion reward', display: '3 нима / 3 nims',
    bonuses: [
      { id: 'break-even-trend', label: 'Бонус за break-even и тренд / Bonus for break-even + trend', amount: 1 },
      { id: 'clean-report', label: 'Бонус за понятный отчёт / Bonus for a clear report', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q6', 'q9'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-8', dayId: 'day-3' },
  nextLessonId: 'max-week-8-day-5'
};

export default maxWeek8Day4;
